export const SELL_HOME_SECTION_STRINGS = {
  'sellHomeSection.title': 'Thinking of selling down\u00a0the\u00a0road?',
  'sellHomeSection.body':
    'We can take care of that too! Apply management fees paid to date as a discount towards our 6%\u00a0brokerage\u00a0fee.',
  'sellHomeSection.ctaLabel': 'LEARN MORE',
};
